import { motion } from "framer-motion";
import { ArrowUpRight, Users } from "lucide-react";
import { track } from "@/lib/analytics";
import { SKOOL_URL, SKOOL_NAME } from "@/lib/data";

const BULLETS = ["Production", "Sound selection", "Music business", "Creative development", "Industry knowledge", "Career strategy"];

export const Community = () => {
  return (
    <section id="community" className="relative py-28 lg:py-40 bg-[#0A0A0A] border-y border-white/10" data-testid="community-section">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-3xl border border-white/12 overflow-hidden p-10 lg:p-16 text-center"
          style={{ background: "radial-gradient(120% 120% at 50% 0%, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0) 55%), #050505" }}
        >
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/50 to-transparent" />
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/15 bg-white/5 mb-8">
            <Users size={14} className="text-white/70" />
            <span className="text-[11px] tracking-[0.2em] uppercase text-white/60">Producer Community</span>
          </div>
          <h2 className="font-heading uppercase tracking-tight text-white text-4xl lg:text-6xl leading-[0.95]">
            {SKOOL_NAME}
          </h2>
          <p className="font-serif-accent italic text-xl lg:text-2xl text-white/50 mt-3">for producers who want to level up</p>
          <p className="text-white/55 mt-6 leading-relaxed text-[15px] max-w-xl mx-auto">
            A community for producers looking to improve their craft and understand the business behind the music.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-2.5 max-w-2xl mx-auto">
            {BULLETS.map((b) => (
              <span key={b} className="px-4 py-2 rounded-full border border-white/12 text-white/65 text-[12px] tracking-[0.06em]" data-testid={`skool-topic-${b}`}>{b}</span>
            ))}
          </div>

          <a
            href={SKOOL_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("skool_click", "community_section")}
            data-testid="skool-cta"
            className="group mt-10 inline-flex items-center gap-2 px-9 py-4 rounded-full bg-gold text-black text-[13px] tracking-[0.14em] uppercase font-medium hover:-translate-y-1 transition-transform duration-300"
          >
            Join the Community
            <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform duration-300" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Community;
